/**
 * Browser-safe React entry point for @cogo/webmcp-runtime.
 * Does NOT include testing utilities (which depend on node:fs).
 *
 * Usage: import { useCogoWebMCP } from "@cogo/webmcp-runtime/react"
 */

// Core (browser-safe)
export {
  CogoToolRegistry,
  type WebMCPTool,
  type WebMCPToolMetadata,
  type JsonSchema,
  type ToolManifestEntry,
  type ToolsChangedListener,
} from "./core/tool-registry"

export {
  validate,
  validateInput,
  validateOutput,
  type ValidationResult,
  type ValidationError,
} from "./core/schema-validator"

export {
  WebMCPStateProvider,
  type StateManagerLike,
} from "./core/state-provider"

// Adapters (browser-safe)
export {
  installRuntimePolyfill,
  uninstallRuntimePolyfill,
  type CogoToolsGlobal,
  type CogoRuntimeRef,
} from "./adapters/runtime-adapter"

export {
  installBrowserAdapter,
} from "./adapters/browser-adapter"

// Renderer integration (browser-safe)
export {
  WebMCPProvider,
  WebMCPContext,
  useWebMCPContext,
  type WebMCPContextValue,
  type WebMCPProviderProps,
  type WebMCPOntologyManifest,
} from "./renderer/webmcp-provider"

export {
  useWebMCPRegistry,
  useWebMCPState,
  useWebMCPTool,
} from "./renderer/use-webmcp"

export {
  createWebMCPIntegration,
  type WebMCPIntegration,
  type WebMCPOptions,
  type CogoRuntimeLike,
  type CogoAppDefLike,
  type CogoBlockDefLike,
} from "./renderer/renderer-plugin"

export {
  useCogoWebMCP,
  type UseCogoWebMCPResult,
} from "./renderer/use-cogo-webmcp"

// Generators (browser-safe)
export { generateFormTools, type FormField, type GeneratorRuntime, type ActionEngineLike } from "./generators/form-tools"
export { generateActionFlowTools } from "./generators/action-flow-tools"
export { generateDataTableTools } from "./generators/data-table-tools"
export { generateNavigationTools } from "./generators/navigation-tools"
export { generateCrudTools } from "./generators/crud-tools"
export {
  generateToolsFromBlock,
  generateToolsFromPage,
  generateToolsFromApp,
} from "./generators/dsl-to-tools"

// NOTE: Testing exports (CogoContractTester, diffManifests, etc.) are NOT included here
// because they depend on node:fs. Use the main entry "@cogo/webmcp-runtime" for testing.
